export function arc(ctx) {
    return {
        styles: {
            // line_width: 25 matches arc_bg (lv_theme_material.c:514, LV_DPX(25)) — was 15,
            // silently overriding the schema's own already-correct Phase 1 default (25) with a
            // wrong theme value. radius: 8 matches the underlying `bg` style's LV_DPX(8)
            // (lv_theme_material.c:209) — was 4 (arbitrary, unconfirmed HaspArc.js rendering
            // reads this at all for the arc-ring background; left as a low-risk numeric
            // correction). main.border_width: 0 is DEFERRED — firmware's `bg` style carries
            // BORDER_WIDTH=2 for ARC_PART_BG, but whether HaspArc.js's canvas rendering ever
            // draws a rect border behind the arc ring (as opposed to only stroking the two
            // line-based arcs) isn't confirmed here; changing it risks an unverified visual
            // regression, so left as-is pending Phase 4 widget-rendering review.
            main:      { ...ctx.pretty, border_width: 1, radius: 5, line_color: ctx.COLOR_BG_SEC, line_width: 16 , padding:10},
            // line_width: 25 matches arc_indic (lv_theme_material.c:509) — was 15, same bug as main.
            indicator: { line_color: ctx.primary, line_width: 25, line_rounded: true },
            // border_width: 2 — arc_knob (lv_theme_material.c:517-522) doesn't override
            // border_width/border_color at all, so the knob (KNOB part uses `bg` + `bg_click` +
            // `arc_knob`) keeps `bg`'s BORDER_WIDTH=2/border_color=COLOR_BG_BORDER — was 0,
            // silently overriding the schema's HASP-theme default (2) down to no border.
            knob:      { bg_color: ctx.COLOR_BG, padding: 0, border_width: 2, border_color: ctx.COLOR_BG_BORDER },
        },
    };
}
